import { render, staticRenderFns } from "./DollarBillSVG.vue?vue&type=template&id=a5488b02"
import script from "./DollarBillSVG.vue?vue&type=script&lang=js"
export * from "./DollarBillSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports